"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindFlowRunsResponse = exports.FindFlowRunsQuery = exports.FlowRunLaunchedByTrigger = exports.FlowRunNodeState = exports.FlowRunState = void 0;
const tslib_1 = require("tslib");
const entity_repository_1 = require("../entity-repository");
tslib_1.__exportStar(require("./flow-node-runs"), exports);
tslib_1.__exportStar(require("./accessors"), exports);
tslib_1.__exportStar(require("./api"), exports);
var FlowRunState;
(function (FlowRunState) {
    FlowRunState["QUEUED"] = "queued";
    FlowRunState["RUNNING"] = "running";
    FlowRunState["COMPLETED"] = "completed";
    FlowRunState["STOPPED"] = "stopped";
    FlowRunState["FAILED"] = "failed";
})(FlowRunState = exports.FlowRunState || (exports.FlowRunState = {}));
var FlowRunNodeState;
(function (FlowRunNodeState) {
    FlowRunNodeState["RUNNING"] = "running";
    FlowRunNodeState["COMPLETED"] = "completed";
    FlowRunNodeState["STOPPED"] = "stopped";
    FlowRunNodeState["FAILED"] = "failed";
})(FlowRunNodeState = exports.FlowRunNodeState || (exports.FlowRunNodeState = {}));
var FlowRunLaunchedByTrigger;
(function (FlowRunLaunchedByTrigger) {
    FlowRunLaunchedByTrigger["ApiTrigger"] = "api-trigger";
    FlowRunLaunchedByTrigger["ScheduleTrigger"] = "schedule-trigger";
    FlowRunLaunchedByTrigger["AppEventTrigger"] = "app-event-trigger";
    FlowRunLaunchedByTrigger["DataSourceTrigger"] = "data-source-trigger";
})(FlowRunLaunchedByTrigger = exports.FlowRunLaunchedByTrigger || (exports.FlowRunLaunchedByTrigger = {}));
class FindFlowRunsQuery extends entity_repository_1.PaginationQuery {
}
exports.FindFlowRunsQuery = FindFlowRunsQuery;
class FindFlowRunsResponse extends entity_repository_1.PaginationResponse {
}
exports.FindFlowRunsResponse = FindFlowRunsResponse;
//# sourceMappingURL=index.js.map